import React from 'react'
import Content from './Components/Content'

const Safety = () => {
    return (
        <div>
            <Content>
                <h1>MDMA SAFETY GUIDE</h1>
                <h3>Bond: 3,4-Methylendioxy-N-methlamphetamine</h3>
                <br />
                <p>When taking MDMA, it is recommended not to exceed a maximum dose of 1.5 mg MDMA per kg bodyweight for men and 1.3 mg MDMA per kg bodyweight for women. In general, a dose of 120 mg should not be exceeded. After ingestion, be sure to hydrate sufficiently. Only obtain MDMA from trustworth sources.</p>

                <br />
                <h3>*Information not guaranteed</h3>
                <p>More info: <a href="https://en.wikipedia.org/wiki/MDMA" target='_blank' rel="noreferrer">Wikipedia.</a></p>
            </Content>
        </div>
    )
}

export default Safety
